import axios from 'axios';
import env from '../config/env';
import { formData } from '../components/utils/formData';
export const POST_MESSAGE = 'POST_MESSAGE';

export function sendMessage(data) {
  const config = { headers: { 'Content-Type': 'multipart/form-data' } };
	const request = axios.post(`${env.url}contact.php`, formData(data), config);

	return {
		type: POST_MESSAGE,
		payload: request
	};
}



// WEBPACK FOOTER //
// ./src/actions/message.js